import ReactDOM from "react-dom/client";

//THeme Akkhor
import './assets/css/bootstrap.min.css';
import './assets/css/fafont.min.css';
import './assets/fonts/flaticon.css'
import './assets/css/style.css'
import './assets/scss/header.scss';
import './assets/scss/notification.scss';
import './assets/scss/sidebar.scss';
import './assets/scss/content.scss';
import './assets/scss/form.scss';
import 'react-confirm-alert/src/react-confirm-alert.css';
//END THeme Akkhor

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import mockAxios from "./mocks";

import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";


// require("dotenv").config();
var axios = require("axios");
const { REACT_APP_USE_MOCK_DATA } = process.env;
if (REACT_APP_USE_MOCK_DATA === "true") mockAxios(axios);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
      <App />
    </PersistGate>
  </Provider>
);

// Nếu bạn dùng CRA có serviceWorker:
serviceWorker.unregister();
